import { lazy } from 'react'

import { WithLoaderSuspense } from '@/components/shared/AstaLoader/AstaLoader'

const StartPage = WithLoaderSuspense(lazy(() => import('./StartPageContainer')))

export default StartPage
